import { isInternationalCountryIsoCode } from '@toasttab/buffet-pui-country-utilities'

import { useAdsManagerConfigQuery } from 'src/apollo/onlineOrdering'
import { useOOClient } from 'shared/components/common/oo_client_provider/OOClientProvider'
import { useOptionalRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'

/**
 * Checks if the restaurant is in the US and has Toast Ads enabled.
 * US restaurants are those that are NOT international.
 * Ads are considered enabled if:
 * 1. adsManagerRestaurantConversionsData has googleConversionsData with tagId (preferred, more reliable)
 * 2. OR google_ads_conversion_tag is present in pixelsV2 (fallback)
 */
export function useSiteHasUsAdsLocation() {
  const res = useOptionalRestaurant()
  const ooClient = useOOClient()
  const site = res?.restaurant

  // Use adsManagerConfig query for more reliable ads detection
  // Must be called before any early returns (React Hooks rule)
  const { data: adsManagerData } = useAdsManagerConfigQuery({
    skip: !res?.ooRestaurant?.guid || !site,
    variables: { restaurantGuid: res?.ooRestaurant?.guid ?? '' },
    client: ooClient
  })

  if (!site) return false

  const hasUsLocation =
    site.locations?.some(
      (loc) => !isInternationalCountryIsoCode(loc.country)
    ) ?? false

  const adsManagerRestaurantConversionsData =
    adsManagerData?.adsManager?.adsManagerRestaurantConversionsData

  // Check if ads are enabled using adsManager data or pixelsV2
  const hasAdsFromAdsManager =
    !!adsManagerRestaurantConversionsData?.googleConversionsData?.tagId ||
    !!adsManagerRestaurantConversionsData?.metaConversionsData?.pixelId

  const hasAdsFromPixelsV2 =
    !!site.pixelsV2?.google_ads_conversion_tag?.content ||
    !!site.pixelsV2?.google_ads_conversion_tag?.scriptArg

  const hasAds = hasAdsFromAdsManager || hasAdsFromPixelsV2

  return hasUsLocation && hasAds
}
